import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollElement =
      document.scrollingElement || document.documentElement || document.body;

    // 页面淡出
    document.body.classList.add("fade-out");

    // 延时滚动与淡入
    const timer = setTimeout(() => {
      scrollElement.scrollTo({ top: 0, behavior: "smooth" });
      document.body.classList.remove("fade-out");
    }, 250); // 延迟 0.25s 做淡出

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
